import { deleteSubWinery, listSubWineriesById } from "../../../actions/subWineryActions";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Translate } from "../../../../language";

export const SubWineriesList = ({history,match}) => {
    let idWinery = match.params.idWinery

    const dispatch = useDispatch();
    const { subWineriesList } = useSelector((state) => state.subWinery);
    useEffect(() => {
        dispatch(listSubWineriesById(idWinery))
    }, [idWinery])
    console.log();
    return (
        <div>            
            {
                subWineriesList.map((element) => (
                    <div key={element._id} className="modal-options-social-list">
                        <div className="row">
                            <h2 >{element.name}</h2>
                            <div onClick={() => dispatch(deleteSubWinery(element._id))} className="">{Translate ('deleteSubWinery', 'es')}</div>
                            <div onClick={() => history.push('/Admin/UpdateSubWinery/' + element._id)} className="pointer ">Editar</div>
                        </div>
                    </div>
                )
                )
            }
        </div>
    )
}
